<template>
  <div class="container"></div>
</template>

<script>
import { agentExport } from '@/apis/order'
export default {
  async created () {
    try {
      const result = await agentExport()
      if (result) {
        window.location.href = result
      }
    } catch (error) {
      this.$message.error(error.message || '网络异常，请稍后再试！')
    }
  }
}
</script>
